module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/twitter-icon-solid-476ba4e1a22a960afcf1109d9580e30e.png";